import React from 'react';
import { createPortal } from 'react-dom';
import './Toast.css';

type Props = {
  toastMessage: string;
};

const Toast = ({ toastMessage }: Props) =>
  createPortal(
    <div className="Toast">
      {toastMessage}
      <div className="Toast-countdown" />
    </div>,
    document.body,
  );

export default Toast;
